import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import viomeLogo from '@/assets/viome-logo.png';
import { Button } from '@design-system/Button';
import { LOGIN_PATH } from '@/constants/paths';

const BACKGROUND_VIDEO_URL =
  'https://s3-figma-videos-production-sig.figma.com/video/1051277534307135341/TEAM/c17b/b1f2/-dd8f-456a-8bc9-b7178d8c3e16?Expires=1734307200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ni8mi-1UcZHgZ3SSTtMf4ZHPWNzynSnbLw7LNFeG5JitUhqnVEJI1SOy8OTz~Y11WAYjjgWFfPpspfgdg2-PfZvHNPIEykcO~tntYgyPN7Gl2nQpVmc5wZUwTIPjfia8HommcgIL6u03l7Dp2sQceqz1x8d6~050hgpl2OA7-W1jr4q4M8kT~N9w4RhSYYqgql631elZRpFdk~7ofnw8yCA3fF-pKKWH~EqBeR7vfvqMW9LQddlYyudS9TaTONusHEDEZ8fGVeXNvhdZZTuLse4AmZSy4j66xR0LAAC1mFsSgAq0E3OY4GjudUpZFSRb2HKDPMNpEiGGihLR332BQQ__';

export const Landing = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Video Element */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={BACKGROUND_VIDEO_URL}
        autoPlay
        loop
        muted
      />

      {/* Content Overlay */}
      <div className="min-h-screen flex flex-col z-10 relative p-8">
        <div className="flex items-center justify-center flex-grow">
          <div className="text-white flex items-center justify-center">
            <div className="flex items-center justify-center flex-grow flex-col">
              <div>
                <img src={viomeLogo} width={42} />
              </div>
              <div className="mt-20 max-w-sm">
                <p className="text-white text-3xl text-center font-serif">
                  Small steps can lead to big discoveries about your health.
                  <br /> Let's go!
                </p>
              </div>
              <div className="flex mt-20">
                <Button type="button" variant="secondary" className="w-[220px]">
                  Register a kit
                </Button>
                <Link to={LOGIN_PATH}>
                  <Button className="w-[220px] bg-[#42434D] bg-opacity-8 ml-2">
                    Login
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="text-white flex items-center justify-center">
            <a
              href="https://viome.com"
              target="_blank"
              className="flex justify-center pb-4 items-center"
            >
              <p className="text-white ">Visit viome.com</p>
              <ChevronRight size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Background Overlay (Optional) */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
    </div>
  );
};
